import './StartingPageContent.scss';

const StartingPageContent = () => {
  return (
    <section className="starting">
      <h1>Welcome on Board!</h1>
    </section>
  );
};

export default StartingPageContent;
